import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/hotel-tariff'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'hotel_tariff_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'hotel_tariff_index', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'hotel_tariff_index',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
